/*
 * Bâan Kumlaï — CRO Vague 1
 * 1. Barre d'achat collante sur la fiche produit
 * 2. Jauge de progression vers la livraison offerte (panier + tiroir)
 *
 * Sans dépendance. N'écrase aucune fonction du thème.
 * Tout est re-résolu à chaque passe : le thème remplace le bloc produit
 * à chaque changement de variante, les références deviennent obsolètes.
 */
(function () {
  'use strict';

  /* Barèmes de livraison relevés le 19 août 2026 dans Parametres > Livraison.
     À remettre à jour si les tarifs ou les zones changent.
     free = seuil de franco en centimes, null = pas de franco sur cette zone.
     freeQty = franco au nombre d'articles (non utilisé : France métropolitaine = dès 42 EUR, annoncé « dès 3 joncs ou 45 € »
     depuis le 22/09/2026, remise automatique "Livraison Gratuite" limitée au pays FR). */
  var EUROPE = ['AL','AD','AT','BE','BG','HR','DK','EE','FI','DE','GR','VA','HU','IS','IE','IT',
    'LV','LI','LT','LU','MT','MD','MC','ME','NL','MK','NO','PL','PT','RO','SM','SK','SI','ES',
    'SE','CH','UA','GB','CZ','GI','GG','RS','SJ'];
  var TOM = ['PF','YT','NC','BL','MF','PM','WF'];
  var DOM = ['GP','MQ','RE'];

  function zone() {
    var c = (window.Shopify && window.Shopify.country) || '';
    if (c === 'FR') return { rate: 490, free: 4200 };
    if (DOM.indexOf(c) > -1) return { rate: 490, free: null };
    if (TOM.indexOf(c) > -1) return { rate: 1290, free: 14900 };
    if (c === 'US') return { rate: 1490, free: null };
    if (EUROPE.indexOf(c) > -1) return { rate: 990, free: 14900 };
    return null; // pays inconnu : on n'annonce rien
  }
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var CSS = [
    '.bk-sticky{position:fixed;left:0;right:0;bottom:0;z-index:60;background:#fff;',
    'border-top:1px solid rgba(0,0,0,.12);box-shadow:0 -2px 16px rgba(0,0,0,.10);',
    'transform:translateY(110%);transition:transform .22s ease;padding:10px 14px;',
    'padding-bottom:calc(10px + env(safe-area-inset-bottom,0px));}',
    '.bk-sticky.is-on{transform:translateY(0);}',
    '.bk-sticky__in{display:flex;align-items:center;gap:12px;max-width:1100px;margin:0 auto;}',
    '.bk-sticky__img{width:44px;height:44px;object-fit:cover;flex:none;border-radius:2px;background:#f3f3f3;}',
    '.bk-sticky__txt{flex:1 1 auto;min-width:0;line-height:1.25;}',
    '.bk-sticky__name{font-size:13px;font-weight:600;color:#111;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '.bk-sticky__meta{font-size:12px;color:#666;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '.bk-sticky__btn{flex:none;border:0;background:#000;color:#fff;font:inherit;font-size:13px;',
    'font-weight:600;letter-spacing:.04em;text-transform:uppercase;padding:13px 18px;cursor:pointer;',
    'border-radius:2px;min-height:44px;}',
    '.bk-sticky__btn[disabled]{opacity:.45;cursor:not-allowed;}',
    '.bk-sticky__btn:focus-visible{outline:2px solid #daac50;outline-offset:2px;}',
    '@media(min-width:750px){.bk-sticky__name{font-size:14px;}.bk-sticky__btn{padding:13px 28px;}}',

    '.bk-ship{margin:0 0 16px;padding:13px 15px;border:1px solid rgba(0,0,0,.12);background:#fbfaf7;border-radius:2px;}',
    '.bk-ship__t{font-size:13.5px;line-height:1.4;color:#111;margin:0 0 9px;}',
    '.bk-ship__t:only-child{margin:0;}',
    '.bk-ship__t b{color:#8a6a1c;font-weight:600;}',
    '.bk-ship__track{height:6px;background:rgba(0,0,0,.10);border-radius:99px;overflow:hidden;}',
    '.bk-ship__fill{height:100%;background:#daac50;border-radius:99px;width:0;transition:width .35s ease;}',
    '.bk-ship.is-done{background:#f1f7f2;border-color:rgba(42,110,82,.28);}',
    '.bk-ship.is-done .bk-ship__fill{background:#2a6e52;}',
    '.bk-ship.is-done .bk-ship__t b{color:#2a6e52;}',
    '@media(prefers-reduced-motion:reduce){.bk-sticky,.bk-ship__fill{transition:none;}}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('bk-cro-css')) return;
    var s = document.createElement('style');
    s.id = 'bk-cro-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ------------------------------------------- 1. barre d'achat collante */

  function addButton() {
    return document.querySelector('form[action*="/cart/add"] [name="add"]');
  }

  function initStickyAtc() {
    if (location.pathname.indexOf('/products/') === -1) return;
    if (!addButton()) return;

    function scope() { return document.querySelector('product-info') || document; }

    var bar = document.createElement('div');
    bar.className = 'bk-sticky';
    bar.innerHTML =
      '<div class="bk-sticky__in">' +
      '<img class="bk-sticky__img" alt="" aria-hidden="true">' +
      '<div class="bk-sticky__txt">' +
      '<div class="bk-sticky__name"></div>' +
      '<div class="bk-sticky__meta"></div>' +
      '</div>' +
      '<button type="button" class="bk-sticky__btn">Ajouter au panier</button>' +
      '</div>';
    document.body.appendChild(bar);

    var barImg = bar.querySelector('.bk-sticky__img');
    var barName = bar.querySelector('.bk-sticky__name');
    var barMeta = bar.querySelector('.bk-sticky__meta');
    var barBtn = bar.querySelector('.bk-sticky__btn');

    var titleEl = document.querySelector('.product__title h1, h1');
    if (titleEl) barName.textContent = titleEl.textContent.trim();

    function priceText() {
      var s = scope();
      var el = s.querySelector('.price-item--sale') ||
               s.querySelector('.price-item--regular') ||
               s.querySelector('.price');
      if (!el) return '';
      var m = el.textContent.match(/[0-9.,]+ ?€/);
      return m ? m[0] : '';
    }

    function sizeText() {
      var s = scope();
      var r = s.querySelector('input[type="radio"]:checked');
      if (r) return r.value;
      var sel = s.querySelector('variant-selects select, .product-form__input select');
      if (sel && sel.selectedOptions[0]) return sel.selectedOptions[0].value;
      return '';
    }

    var queued = false;
    function update() {
      queued = false;
      var btn = addButton();
      if (!btn) { bar.classList.remove('is-on'); return; }

      var r = btn.getBoundingClientRect();
      bar.classList.toggle('is-on', r.bottom < 0); // visible une fois le bouton depasse

      barMeta.textContent = [sizeText(), priceText()].filter(Boolean).join(' · ');
      if (btn.disabled) {
        barBtn.setAttribute('disabled', 'disabled');
        barBtn.textContent = (btn.textContent || '').trim().slice(0, 24) || 'Indisponible';
      } else {
        barBtn.removeAttribute('disabled');
        barBtn.textContent = 'Ajouter au panier';
      }

      var img = document.querySelector('.product__media img, .product-media-container img');
      if (img && img.currentSrc && img.currentSrc !== barImg.src) barImg.src = img.currentSrc;
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.setTimeout(update, 16);
    }

    barBtn.addEventListener('click', function () {
      var btn = addButton();
      if (btn && !btn.disabled) btn.click();
    });

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    new MutationObserver(schedule).observe(document.body, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['disabled', 'checked', 'class', 'src']
    });
    document.addEventListener('change', schedule);
    update();
  }

  /* -------------------------------------- 2. jauge livraison offerte */

  function shipHtml(subtotal, count) {
    var z = zone();
    if (!z) {
      return { done: false, bar: false,
        html: '<p class="bk-ship__t">Frais de livraison calculés à l’étape du paiement.</p>' };
    }
    if (z.freeQty) {
      var reste = z.freeQty - (count || 0);
      var acquis = reste <= 0;
      var part = Math.max(0, Math.min(100, ((count || 0) / z.freeQty) * 100));
      var msg = acquis
        ? '<b>Livraison offerte</b> — c’est acquis pour cette commande.'
        : 'Plus que <b>' + reste + ' jonc' + (reste > 1 ? 's' : '') + '</b> pour la livraison offerte. Sinon, livraison <b>'
          + money(z.rate) + '</b>.';
      return {
        done: acquis, bar: true,
        html: '<p class="bk-ship__t">' + msg + '</p>' +
              '<div class="bk-ship__track"><div class="bk-ship__fill" style="width:' + part.toFixed(1) + '%"></div></div>'
      };
    }
    if (z.free === null) {
      return { done: false, bar: false,
        html: '<p class="bk-ship__t">Livraison suivie : <b>' + money(z.rate) + '</b>.</p>' };
    }
    var left = z.free - subtotal;
    var done = left <= 0;
    var pct = Math.max(0, Math.min(100, (subtotal / z.free) * 100));
    var text = done
      ? '<b>Livraison offerte</b> — c’est acquis pour cette commande.'
      : 'Plus que <b>' + money(left) + '</b> pour la livraison offerte. Sinon, livraison <b>'
        + money(z.rate) + '</b>.';
    return {
      done: done, bar: true,
      html: '<p class="bk-ship__t">' + text + '</p>' +
            '<div class="bk-ship__track"><div class="bk-ship__fill" style="width:' + pct.toFixed(1) + '%"></div></div>'
    };
  }

  function shipHosts() {
    var out = [];
    [
      '#main-cart-footer .cart__footer > div',
      '#main-cart-footer .cart__footer',
      '.cart__footer',
      'cart-drawer .drawer__footer',
      'cart-notification .cart-notification__links'
    ].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && out.indexOf(el) === -1 && !out.some(function (o) { return o.contains(el) || el.contains(o); })) {
        out.push(el);
      }
    });
    return out;
  }

  function renderShip(subtotal, itemCount) {
    shipHosts().forEach(function (host) {
      var box = host.querySelector('.bk-ship');
      if (!itemCount) { if (box) box.remove(); return; }
      if (!box) {
        box = document.createElement('div');
        box.className = 'bk-ship';
        host.insertBefore(box, host.firstChild);
      }
      var m = shipHtml(subtotal, itemCount);
      box.classList.toggle('is-done', m.done);
      box.innerHTML = m.html;
    });
  }

  var lastCart = null;

  function applyCart(cart) {
    lastCart = cart;
    var sub = typeof cart.items_subtotal_price === 'number'
      ? cart.items_subtotal_price
      : cart.total_price;
    renderShip(sub, cart.item_count);
  }

  function refreshCart() {
    var url = (ROOT.charAt(ROOT.length - 1) === '/' ? ROOT : ROOT + '/') + 'cart.js';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) applyCart(cart); })
      .catch(function () { /* silencieux : ne jamais casser la page */ });
  }

  function watchCart() {
    if (window.fetch && !window.__bkFetchPatched) {
      window.__bkFetchPatched = true;
      var orig = window.fetch;
      window.fetch = function () {
        var u = String((arguments[0] && arguments[0].url) || arguments[0] || '');
        var p = orig.apply(this, arguments);
        if (u.indexOf('/cart/add') > -1 || u.indexOf('/cart/change') > -1 ||
            u.indexOf('/cart/update') > -1 || u.indexOf('/cart/clear') > -1) {
          p.then(function () { setTimeout(refreshCart, 80); }).catch(function () {});
        }
        return p;
      };
    }
    // Le theme reinjecte le tiroir / la notification : on re-rend depuis le
    // cache, sans requete. Sinon chaque mutation du DOM declencherait un appel.
    new MutationObserver(function () {
      if (!lastCart || !lastCart.item_count) return;
      if (shipHosts().some(function (h) { return !h.querySelector('.bk-ship'); })) applyCart(lastCart);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    injectCSS();
    initStickyAtc();
    watchCart();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
